import {registerWithSID} from 'src/assets/js/utils/register_with_sid.js';

app.modules.favoriteCompanies = ((self = {}) => {
  function _handleFavoriteButtonClick(event) {
    const favoriteButton = event.target.closest('.js-favorite-company-button');

    if (!favoriteButton) return;

    event.preventDefault();
    app.config.isUserSigned
      ? _toggleFavoriteButtonState(favoriteButton)
      : registerWithSID().then(() =>
          _toggleFavoriteButtonState(favoriteButton)
        );
  }

  function _toggleFavoriteButtonState(favoriteButton) {
    const {companyId, isFavorite} = favoriteButton.dataset;
    const isFavoriteBool = JSON.parse(isFavorite);

    _sendRequest(isFavoriteBool, companyId).then(() => {
      favoriteButton.dataset.isFavorite = !isFavoriteBool;
      if (!favoriteButton.innerText) return;
      favoriteButton.innerText = isFavoriteBool
        ? app.locales.addToFavorite
        : app.locales.inFavorite;
    });
  }

  function _sendRequest(isFavorite, companyId) {
    return fetch(
      `${app.config.api.favoriteCompanies}?company_id=${companyId}`,
      {
        method: isFavorite ? 'DELETE' : 'POST',
        headers: {Accept: 'application/json'},
      }
    )
      .then((res) => res.json())
      .catch(console.error);
  }

  function _addListener() {
    document.addEventListener('click', _handleFavoriteButtonClick);
  }

  function _init() {
    _addListener();
  }

  self.load = _init;
  return self;
})(app.modules.favoriteCompanies);
